const get = (cname) => {
	let name = cname + '='
	let decodedCookie = decodeURIComponent(document.cookie)
	let ca = decodedCookie.split(';')
	for (var i = 0; i < ca.length; i++) {
		let c = ca[i]
		while (c.charAt(0) === ' ') {
			c = c.substring(1)
		}
		if (c.indexOf(name) === 0) {
			return c.substring(name.length, c.length)
		}
	}
	return ''
}

const set = (cname, value) => {
	document.cookie = cname + '=' + value
}

const cookie = {
	get: get,
	set: set
}

export const VueCookie = {
	install: function (Vue) {
		Vue.prototype.$cookie = cookie
	}
}



// WEBPACK FOOTER //
// ./src/common/services/Cookie.js